import React from 'react';
import PropTypes from 'prop-types';
import Card from 'common/card/Card';
import GettingThere from 'spot-details/getting-there/GettingThere';
import SpotDetailsDirectionsMap from '../../map/SpotDetailsDirectionsMap';

const DirectionsCardPanel = ({facility, selectedRate, isMonthly}) => {
    const {
        latitude,
        longitude,
        airport: {
            details: {
                latitude: destinationLatitude,
                longitude: destinationLongitude,
            },
        },
    } = facility;

    return (
        <Card className="DirectionsCardPanel" title="Directions">
            <GettingThere
                facility={facility}
                rate={selectedRate}
                isMonthly={isMonthly}
            />
            <SpotDetailsDirectionsMap
                spotLatitude={latitude}
                spotLongitude={longitude}
                destinationLatitude={destinationLatitude}
                destinationLongitude={destinationLongitude}
                isDriving
                isDraggable
            />
        </Card>
    );
};

DirectionsCardPanel.propTypes = {
    facility: PropTypes.object.isRequired,
    selectedRate: PropTypes.oneOfType([PropTypes.object, PropTypes.bool])
        .isRequired,
    isMonthly: PropTypes.bool,
};

export default DirectionsCardPanel;
